import type { IGDPRFilesResources } from "./GDPRFiles.Resources";

export const GDPRFilesResourcesEn: IGDPRFilesResources = {
    title: "GDPR - data copy",
    description:
        "Below you can find data file, you have been requesting as part of the GDPR procedures",
    downloadButton: "Download {0} file",
    fileSize: "File size: {0}",
    fileDate: "File creation date: {0}",
};
